import Carousel from '../../components/base/Carousel';

/**
 * Карусель "Советы эксперта"
 */
export default () => {
    $(document).ready(() => {
        const $carouseAdvices = $('.carousel--advices');
        const advicesCarousel = new Carousel($carouseAdvices);

        advicesCarousel.init(
            { spaceBetween: 12, loop: false },
            { slidesPerView: 3, breakpoints: { 1023: { slidesPerView: 2 }, 767: { slidesPerView: 1 } } }
        );
    });
};
